<script>
import TabsSelector from "@/views/app/dashboard/history/components/TabsSelector.vue";

export default {
  components: {
    TabsSelector,
    TransactionHistory: () => import("@/views/app/dashboard/history/components/TransactionHistory.vue"),
    GameHistory: () => import("@/views/app/dashboard/history/components/GameHistory.vue"),
    // BonusHistory: () => import("@/views/app/dashboard/history/components/BonusHistory.vue"),
  },

  data: () => ({
    filter: {},
    selectedTab: "TransactionHistory",

    search: "",
    firstname: "",
    lastname: "",
    address: "",
    city: "",
    sitecontactnumber: "",
    dateofbirth: "",
    displayName: "",
    country: " ",
    emptyColorFill: {
      radial: true,
      colors: [
        {
          color: "#ce952e",
          offset: "50",
          opacity: "0.2",
        },
        {
          color: "#ce952e",
          offset: "50",
          opacity: "0.15",
        },
        {
          color: "#ce952e",
          offset: "70",
          opacity: "0.15",
        },
        {
          color: "#ce952e",
          offset: "70",
          opacity: "0.1",
        },
        {
          color: "#ce952e",
          offset: "90",
          opacity: "0.1",
        },
        {
          color: "transparent",
          offset: "90",
          opacity: "0.1",
        },
        {
          color: "transparent",
          offset: "95",
          opacity: "0.1",
        },
        {
          color: "transparent",
          offset: "95",
          opacity: "0.1",
        },
      ],
    },
    progdata: [
      {
        progress: 50, // required for each circle
        color: "#ce952e", // will overwrite global progress color
      },
      // {
      //   progress: 50, // required for each circle
      //   animation: 'rs 1500 500' // you can set almost any option that will be specific to this circle
      // }
    ],
    gradient: {
      radial: false,
      colors: [
        {
          color: "#ce952e",
          offset: 0,
          opacity: "1",
        },
        {
          color: "#000000",
          offset: 100,
          opacity: "0.6",
        },
      ],
    },

    loading: false,
  }),

  watch: {
    async loading(val) {
      if (!val) return;
      await this.$nextTick();
      this.loading = false;
    },
  },

  computed: {
    playerInfo() {
      return this.$store.getters.getPlayerInfo;
    },
  },

  created() {
    this.loading = true;
    this.$store.dispatch("getPlayerInfo");
  },
  methods: {},
};
</script>

<template>
  <v-row class="h-100">
    <v-col
      cols="12"
      v-if="loading"
      class="d-grid justify-items-center align-center"
    >
      <vue-ellipse-progress
        :data="progdata"
        :progress="100"
        :gradient="gradient"
        empty-color="grey"
        dash="strict 60 0.8"
        :size="350"
        :thickness="7"
        :empty-thickness="3"
        line-mode="out 5"
        :legend="false"
        animation="rs 700 1000"
        font-size="1.5rem"
        :loading="true"
        :empty-color-fill="emptyColorFill"
      >
        <v-icon slot="legend-caption" size="46" color="#F8BF1E">
          mdi-sword-cross
        </v-icon>
      </vue-ellipse-progress>
    </v-col>
    <div class="historyWindow" v-if="!loading">
      <tabs-selector v-model="selectedTab" @change="selectedTab = $event" />

      <div
        :class="{
          'pl-12 pr-4': $vuetify.breakpoint.mdAndUp,
          'px-4': $vuetify.breakpoint.smAndDown,
        }"
        class="content-container modal-shadow pt-5 pb-10"
      >
        <v-fade-transition mode="out-in">
          <component :is="selectedTab" />
        </v-fade-transition>
      </div>
    </div>
  </v-row>
</template>

<style lang="scss" scoped>
.historyWindow {
  width: 96%;
  max-width: 1080px;
  margin: auto !important;
  padding-top: 50px;
  padding-bottom: 50px;
  border-radius: 20px;

  .content-container {
    background: #412a55;
    border-radius: 0 0 20px 20px;
    color: white;
    font-size: 18px;
    font-style: italic;

    &::v-deep {
      .v-btn {
        border-radius: 10px !important;
      }

      .table-container {
        //display: flex;
        //align-items: center;
        //justify-content: center;
        max-height: 40vh;
        min-height: 400px;
        overflow: auto;
        padding-right: 15px !important;

        /* scrollbar */
        &::-webkit-scrollbar {
          width: 14px !important;
          background: transparent !important;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          width: 14px !important;
          background: #f5f5f5 !important;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          box-shadow: none;
          width: 14px !important;
          background: #2e1f38;
          border-radius: 10px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .historyWindow {
    padding-right: 8px;
    padding-left: 8px;
  }
}

@media screen and (max-width: 600px) {
  .historyWindow {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }
}
</style>

<!--<style lang="scss">-->
<!--</style>-->
